import { queryData } from "@/modules/queryData";
import {
    TEAMS_ENTRY_FROM,
    TEAMS_PARSED_DATA
} from "@/modules/queryData.types";

let teamsInfoCache: TEAMS_PARSED_DATA;
export function getTeamsDataFromUrl() {
    if (teamsInfoCache) return teamsInfoCache;
    if (queryData.teamsDataParsed) {
        teamsInfoCache = queryData.teamsDataParsed;
        return teamsInfoCache;
    }

    // FIXME compatible with previous version
    teamsInfoCache = {
        contentUrl: queryData.contentUrl,
        isChannel: queryData.channelType === 'channel',
        entryFrom: TEAMS_ENTRY_FROM.LEGACY,
        email: queryData.teamsuseremail,
        nickname: queryData.teamsnickname,
        chatUserId: queryData.chatUserId,
    };
    return teamsInfoCache;
}
